import { withStyles } from '@material-ui/core';
import BadgeList from './BadgeList';

const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  driverName: {
    margin: '8px 0px'
  },
  detailsContainer: {
    display: 'flex'
  },
  value: {
    color: theme.TextColor,
    fontSize: theme.textFontSize
  },
  upperCase: {
    textTransform: 'uppercase'
  }
});
const ProDetails = ({ classes, proData }) => {
  return (
    <div className={classes.container}>
      <div className={classes.detailsContainer}>
        <div className={classes.value}>{`PRO #${proData.proId}`}</div>
      </div>
      <BadgeList
        pieces={proData.pieces}
        weight={proData.weight}
        palletCount={proData.palletCount}
        hu={proData.hu}
        pse={proData.pse}
      />
    </div>
  );
};

export default withStyles(styles)(ProDetails);
